<dx-popup
  [title]="titleText"
  [showTitle]="!!titleText"
  [(visible)]="visible"
  [fullScreen]="!!(screen.xSmallScreenChanged | async)"
  [width]="width"
  [wrapperAttr]="getWrapperAttrs | apply: wrapperAttr"
  (onHidden)="close()"
  [height]="height"
  [resizeEnabled]="true"
  [showCloseButton]="true"
>
  <dxi-toolbar-item toolbar="bottom" location="center">
    <div
      class="form-popup-buttons-container"
      [class.flex-buttons]="width <= 360"
    >
      <dx-button
        text="İptal"
        stylingMode="outlined"
        type="normal"
        (onClick)="close()"
      ></dx-button>
      <dx-button
        text="Kaydet"
        stylingMode="contained"
        type="default"
        [disabled]="isSaveDisabled"
        (onClick)="onSaveClick()"
      ></dx-button>
    </div>
  </dxi-toolbar-item>
  <dx-validation-group #validationGroup>
    <ng-content></ng-content>
  </dx-validation-group>
</dx-popup>
